import React from "react";
import { Sparkles, Users, Calendar, Briefcase, HelpCircle } from "lucide-react";

const EmptyState = ({ suggestedQuestions, onSelectQuestion }) => {
  const categories = [
    {
      id: "employees",
      title: "Employés",
      icon: Users,
      color: "from-blue-500 to-indigo-600",
      bgColor: "bg-blue-50",
      textColor: "text-blue-600",
      questions: [
        "Combien d'employés sont enregistrés ?",
        "Qui est le manager de Mariem Khalfallah ?",
      ],
    },
    {
      id: "leaves",
      title: "Congés",
      icon: Calendar,
      color: "from-emerald-500 to-teal-600",
      bgColor: "bg-emerald-50",
      textColor: "text-emerald-600",
      questions: [
        "Quels congés sont en attente ?",
        "Quel est mon solde de congé ?",
      ],
    },
    {
      id: "recruitment",
      title: "Recrutement",
      icon: Briefcase,
      color: "from-purple-500 to-pink-600",
      bgColor: "bg-purple-50",
      textColor: "text-purple-600",
      questions: [
        "Quelle offre est située à Ariana ?",
        "Quel est le meilleur candidat ?",
      ],
    },
    {
      id: "platform",
      title: "Plateforme",
      icon: HelpCircle,
      color: "from-orange-500 to-red-600",
      bgColor: "bg-orange-50",
      textColor: "text-orange-600",
      questions: [
        "Comment fonctionne le RAG ?",
        "Quelles sont les fonctionnalités de la plateforme ?",
      ],
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full text-center p-8 animate-fade-in">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-emerald-500 to-teal-600 w-24 h-24 rounded-full flex items-center justify-center mb-6 shadow-lg">
        <Sparkles className="w-12 h-12 text-white" />
      </div>
      
      <h3 className="text-2xl font-bold text-gray-900 mb-2">
        Comment puis-je vous aider aujourd'hui ?
      </h3>
      <p className="text-gray-600 mb-8 max-w-md">
        Posez vos questions en langage naturel sur les employés, les congés, les offres d'emploi, les candidats et bien plus encore.
      </p>

      {/* Suggested Questions by Category */}
      <div className="w-full max-w-4xl">
        <div className="suggestion-grid">
          {categories.map((category) => {
            const Icon = category.icon;
            return (
              <div
                key={category.id}
                className="suggestion-card"
              >
                <div className="flex items-center space-x-3 mb-3">
                  <div className={`w-10 h-10 bg-gradient-to-br ${category.color} rounded-xl flex items-center justify-center`}>
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <h4 className="font-semibold text-gray-900">{category.title}</h4>
                </div>
                <div className="space-y-2">
                  {category.questions.map((question, index) => (
                    <button
                      key={index}
                      onClick={() => onSelectQuestion(question)}
                      className="w-full text-left px-3 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg transition-colors block"
                    >
                      {question}
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Status Indicator */}
      <div className="mt-8 inline-flex items-center px-4 py-2 bg-emerald-50 text-emerald-700 rounded-full text-sm font-medium">
        <span className="w-2 h-2 bg-emerald-500 rounded-full mr-2 animate-pulse"></span>
        Prêt à vous aider
      </div>
    </div>
  );
};

export default EmptyState;
